import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IHospitalStore, IThunkGetHospitalEvents } from '../types';

const onGetHospitalEvents: IThunkGetHospitalEvents = thunk(
  // @ts-ignore
  async ({ setHospitalEvents, reset }, payload, { getState }) => {
    reset();

    const localState = getState() as IHospitalStore;
    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.hospital.getEventsList({
      ...payload,
      ...paginationPayload,
    });

    setHospitalEvents(data ?? []);
  },
);

export default onGetHospitalEvents;
